<mat-drawer-container class="flex-auto h-full" style="width: 100vw; height: calc(100vh - 120px) !important;">
    <!-- Drawer -->
    <mat-drawer
        #matDrawer
        [autoFocus]="false"
        [mode]="'over'"
        [opened]="false"
        class="w-72 dark:bg-gray-900">
        <!-- Demo sidebar -->
        <table-sidebar [pos]="pos"></table-sidebar>
    </mat-drawer>

    <!-- Drawer content -->
    <mat-drawer-content class="flex flex-col">

        <!-- Main -->
        <div class="flex-auto p-6 sm:p-10">
            <div style="display: flex;justify-content: space-between; align-items: center; margin-bottom: 16px">
                <div>
                    <ng-content select="[heading]">
                    </ng-content>
                    <ng-content select="[breadcrumbs]"></ng-content>
                </div>

                <div>
                    <!-- Drawer toggle -->
                    <button
                        (click)="showOrder()"
                        class="mb-4"
                        mat-icon-button>
                        <mat-icon [svgIcon]="'mat_outline:receipt'"></mat-icon>
                    </button>

                    <!-- Drawer toggle -->
                    <button
                        (click)="matDrawer.toggle()"
                        class="mb-4"
                        mat-icon-button>
                        <mat-icon [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
                    </button>
                </div>

            </div>


            <!-- CONTENT GOES HERE -->
            <div>
                <ng-content select="[content]"></ng-content>
            </div>

        </div>

    </mat-drawer-content>

</mat-drawer-container>
